<template>
  <div class="footer">
    <div class="serves">
      <div class="max-w flex">
        <div class="serve flex" v-for="item in serveList" :key="item.title">
          <i :class="item.icon"></i>{{ item.title }}
        </div>
      </div>
    </div>
    <div class="link-warp">
      <div class="max-w flex">
        <div class="links flex">
          <div class="link">
            <div class="title">个人中心</div>
            <div class="childern">
              <router-link to="/usercenter/order">我的订单</router-link>
              <router-link to="/usercenter/aftersale">售后订单</router-link>
              <router-link to="/usercenter/bargain">我的询价</router-link>
              <router-link to="/usercenter/sourcing">我的寻源</router-link>
            </div>
          </div>
          <div class="link">
            <div class="title">商家服务</div>
            <div class="childern">
              <router-link v-if="appStores.showShopCenter" :to="{ path: appStores.shopCenterFirstRoute }"
                >商家中心</router-link
              >
              <router-link v-else to="/merchantService">商家入驻</router-link>
            </div>
          </div>
          <div class="link">
            <div class="title">采购服务</div>
            <div class="childern">
              <router-link v-if="appStores.showEntertainment" :to="{ path: appStores.entertainmentFirstRoute }"
                >销售中心</router-link
              >
              <router-link v-else to="/buyerService">升级采购服务</router-link>
              <router-link to="/brand">品牌专区</router-link>
            </div>
          </div>
          <div class="link">
            <div class="title">商城操作助手</div>
            <div class="childern">
              <a href="https://download.zhidiancloud.com/videos/20240108-130810-xdjs.mp4" target="_blank">操作视频</a>
              <router-link to="/news">最新资讯</router-link>
            </div>
          </div>
        </div>

        <div class="QRS flex">
          <div class="qr">
            <img
              :src="appStores.appSetting.wxQR ? appStores.appSetting.wxQR : require('@/assets/images/WeChat.jpg')"
              alt="qr"
            />
            <p>微信公众号</p>
          </div>
          <div class="qr">
            <img src="@/assets/images/customerService.png" alt="qr" />
            <p>微信客服</p>
          </div>
          <div class="qr">
            <img src="@/assets/images/卖家版.jpg" alt="qr" />
            <p>小程序-卖家版</p>
          </div>
          <div class="qr">
            <img src="@/assets/images/买家版.jpg" alt="qr" />
            <p>小程序-买家版</p>
          </div>
        </div>
      </div>
    </div>

    <div class="quickLinks">
      <div class="max-w">
        <a
          :href="item.url"
          v-for="(item, index) in appStores.appSetting.quickLink"
          :key="'quick' + index"
          target="_blank"
          >{{ item.title }}</a
        >
      </div>
    </div>
    <div class="copyright">
      <div class="max-w">
        <span>Copyright &copy;</span>
        <span>2022 - {{ dayjs().year() }}</span>
        <span>{{ hostUrl }}</span>
        <span>All Rights Reserved.</span>
        <span>智能电气产业大脑 版权所有</span>
        <a href="http://beian.miit.gov.cn/" target="_blank">{{ appStores.appSetting.icp }}</a>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { appInfo } from '@/stores/appInfo';
import dayjs from 'dayjs';
const hostUrl = document.domain.toUpperCase();
const appStores = appInfo();
const serveList = ref([
  {
    icon: 'mro MRO-shangpin',
    title: '商品多样丰富',
  },
  {
    icon: 'mro MRO-fuwu',
    title: '服务专业可靠',
  },
  {
    icon: 'mro MRO-zhiliang',
    title: '质量正品保证',
  },
  {
    icon: 'mro MRO-gouwu',
    title: '购物便捷方便',
  },
  {
    icon: 'mro MRO-xiaofei',
    title: '消费信赖放心',
  },
]);
</script>
<style lang="scss" scoped>
.footer {
  background: #0c2032;

  .serves {
    padding: 40px 0;
    color: $main-text-color1;
    font-size: 16px;
    font-weight: bold;
    color: #c0c4cc;

    .flex {
      // justify-content: space-around;

      i {
        border: 1px solid #c0c4cc;
        border-radius: 100%;
        font-weight: normal;
        margin-right: 8px;
        font-size: 34px;
        padding: 0 3px;
      }
    }
  }

  .link-warp {
    .flex {
      .links {
        align-items: flex-start;

        .link {
          margin-right: 72px;
          white-space: nowrap;

          .title {
            font-size: 14px;
            font-weight: normal;
            color: #ffffff;
            margin-bottom: 24px;
          }

          .childern {
            a {
              display: block;
              margin-top: 12px;
              font-size: 14px;
              color: #c0c4cc;
            }
          }
        }
      }

      .QRS {
        .qr {
          text-align: center;
          width: 80px;
          margin-right: 48px;

          img {
            border-radius: 6px;
          }

          &:last-child {
            margin: 0;
          }

          p {
            margin: 0;
            margin-top: 8px;
            font-size: 12px;
            color: #c0c4cc;
          }
        }
      }
    }
  }

  .quickLinks,
  .copyright {
    color: #c0c4cc;
    font-size: 14px;

    a {
      color: #c0c4cc;
    }

    span {
      padding: 0 4px;
    }
  }

  .quickLinks {
    margin-top: 50px;

    .max-w {
      a {
        border-right: 1px solid $main-text-color2;
        padding-right: 24px;
        margin-right: 24px;

        &:last-child {
          border: none;
        }
      }
    }
  }

  .copyright {
    padding: 14px 0 24px;
  }
}
</style>
